export default __webpack_public_path__ + "static/media/logo_wide.b22d81fa.svg";